// @ts-nocheck

/**
 * * `observer` - observer
 * `combiner` - combiner
 * `storyteller` - storyteller
 * `explorer` - explorer
 */
export type ReaderProfileDataLanguageLevelEnum =
  typeof ReaderProfileDataLanguageLevelEnum[keyof typeof ReaderProfileDataLanguageLevelEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReaderProfileDataLanguageLevelEnum = {
  observer: "observer",
  combiner: "combiner",
  storyteller: "storyteller",
  explorer: "explorer",
} as const;
